import { useLocalization } from "@fluent/react";
import type React from "react";
import { Button } from "@narmi/design_system";
import { ContextForm } from "cerulean";

interface NewUserActionsProps {
  onSubmit: (callback: () => void) => void;
  onCancel: () => void;
  isDisabled?: boolean;
  submitLabel?: string;
  showBackButton?: boolean;
}

const NewUserActions: React.FC<NewUserActionsProps> = ({
  onSubmit,
  onCancel,
  isDisabled = false,
  submitLabel = "Submit",
}) => {
  const { l10n } = useLocalization();

  return (
    <ContextForm.ActionBar
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "var(--space-l)",
        marginTop: "var(--space-xl)",
        flexDirection: "row-reverse",
      }}
    >
      <ContextForm.Action onSubmit={onSubmit}>
        <Button
          label={submitLabel}
          disabled={isDisabled}
        />
      </ContextForm.Action>
      <ContextForm.Action
        noValidation
        onSubmit={onCancel}
        dangerouslyDisableShowLoading
      >
        <Button
          kind="negative"
          label={l10n.getString("new-user-button-cancel")}
        />
      </ContextForm.Action>
    </ContextForm.ActionBar>
  );
};

export default NewUserActions;
